module.exports = __webpack_public_path__ + "media/src/application/media/svg/routes-c3a136bf16a0d525b819bd1694223e0c.svg";